import dynamic from 'next/dynamic';
import { MultiStepFormSkeleton } from '../MultiStepForm/MultiStepFormSkeleton/MultiStepFormSkeleton';

export const DynamicMultiStepForm = dynamic(
  () => import(/* webpackChunkName: 'AddReview_Dialog' */ '../MultiStepForm/MultiStepForm.client'),
  { ssr: false, loading: () => <MultiStepFormSkeleton /> },
);
